import { render, staticRenderFns } from "./RadioItem.vue?vue&type=template&id=6a8634e0&scoped=true&"
import script from "./RadioItem.vue?vue&type=script&lang=js&"
export * from "./RadioItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8634e0",
  null
  
)

export default component.exports